import { render, staticRenderFns } from "./SurveyGraph.vue?vue&type=template&id=654840c2&scoped=true&"
import script from "./SurveyGraph.vue?vue&type=script&lang=js&"
export * from "./SurveyGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654840c2",
  null
  
)

export default component.exports